import React from "react";
import { gamesDashboardEvent, gamesModifyStatsEvent } from "src/services/ApolloService";
import styles from "./styles.scss";

const folderIconMobile = "/icon/folder-icon-mobile.png";
const addIconMobile = "/icon/add-icon-mobile.png";

const MobileDropdownControls = React.memo(({ isTrendingBetsPage }: { isTrendingBetsPage: boolean }) => {
  return (
    <div className="d-sm-none games-mobile-dropdown-controls">
      {!isTrendingBetsPage ? (
        <>
          <img
            className="toggle-button lazyload"
            src={folderIconMobile}
            alt="Folder Icon"
            onClick={(e) => gamesDashboardEvent(e)}
          />
          <img
            className="toggle-button lazyload"
            data-src={addIconMobile}
            alt="Add Icon"
            onClick={(e) => gamesModifyStatsEvent(e)}
          />
        </>
      ) : null}
      <style jsx>{styles}</style>
    </div>
  );
});

export default MobileDropdownControls;
